
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advocacy/federal/bulletin",
      function () {
        return require("private-next-pages/advocacy/federal/bulletin.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advocacy/federal/bulletin"])
      });
    }
  